import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

import { ConnectedPage } from './../root_classes/connected-page';
import { ConstantsModule } from './../constants/constants.module';
import { UserAddComponent } from './../user-add/user-add.component';
import { UserEditComponent } from './../user-edit/user-edit.component';
import { FolderAddComponent } from '../folder-add/folder-add.component';
import { FolderEditComponent } from '../folder-edit/folder-edit.component';
import { FolderEditRightsComponent } from '../folder-edit-rights/folder-edit-rights.component';
import { FolderUpdaterComponent } from '../folder-updater/folder-updater.component';
import { FolderReminderComponent } from '../folder-reminder/folder-reminder.component';
import { FolderEditMailComponent } from '../folder-edit-mail/folder-edit-mail.component';
import { FolderRestartComponent } from '../folder-restart/folder-restart.component';
import { FolderStartComponent } from '../folder-start/folder-start.component';
import { UserGenerateNewPasswordComponent } from '../user-generate-new-password/user-generate-new-password.component';

@Component({
	selector: 'app-company-detail',
	templateUrl: './company-detail.component.html',
	styleUrls: ['./company-detail.component.scss']
})
export class CompanyDetailComponent extends ConnectedPage implements OnInit {

	private _companyId: string = "";
	public companyName: string = "";

	public userStateChoice: any[] = [];
	public folderStateChoice: any[] = [];
	public roleChoice: any[] = [];

	// Gestion de la liste des dossiers.
	public columnsFolder: any[] = [];
	public datasFolder: any[] = [];
	public firstFolder: number = 0;
	public rowsFolder: number = 10;
	// Gestion de la liste des utilisateurs.
	public columnsUser: any[] = [];
	public datasUser: any[] = [];
	public firstUser: number = 0;
	public rowsUser: number = 10;

	constructor(private activatedRoute: ActivatedRoute, constantsModule: ConstantsModule, cookieService: CookieService, httpClient: HttpClient, router: Router, modalService: NgbModal) {
		super(constantsModule, cookieService, httpClient, router, modalService);

		this.roleChoice = [
			{label: "Utilisateur", value:"U"},
			{label: "Ingénieur", value:"I"},
			{label: "Administrateur", value:"A"}
		];

		// Creating filter list.
		this.userStateChoice = [
			{label: "Actif", value:'true'},
			{label: "Désactivé", value:'false'}
		];

		// Creating filter list.
		this.folderStateChoice = [
			{label: "En attente", value:'D'},
			{label: "En cours", value:'R'},
			{label: "Terminé", value:'E'},
			{label: "Désactivé", value:'X'}
		];
	}

	ngOnInit(): void {
		// Lecture des paramètres depuis la route.
		this._companyId = this.activatedRoute.snapshot.params.id;

		var newDatas = { companyid: this._companyId };

		// Loading company name.
		this.put("/api/company-name", newDatas,
			 (data) => {
				// Storing company name.
				 if (data.DATA == "OK") {
					this.companyName = data.RES;
				} else {
					this.alertLine.alertDangerMessage = "Erreur d'accès à la base de données. Contactez votre administrateur.";
				}
			 },
			 (err) => {
				 this.alertLine.alertDangerMessage = "Erreur d'accès à la base de données. Contactez votre administrateur.";
			 }
		);

		// Init folders list.
		this.firstFolder = 0;
		this.columnsFolder = [
			{field:"name", header:"Nom", sort:"name"},
			{field:"state", header:"Etat", sort:"state"},
			{field:"path", header:"Chemin", sort:"path"},
			{field:"endDateVal", header:"Date d'arrêt", sort:"endDateVal"},
		];

		// Loading folders list.
		this.put("/api/company-detail-list-folder", newDatas,
			 (data) => {
				 // Storing list of folders.
				 if (data.DATA == "OK") {
					this.datasFolder = data.RES;
				} else {
					this.alertLine.alertDangerMessage = "Erreur d'accès à la base de données. Contactez votre administrateur.";
				}
			 },
			 (err) => {
				 this.alertLine.alertDangerMessage = "Erreur d'accès à la base de données. Contactez votre administrateur.";
			 }
		);

		// Init users list.
		this.firstUser = 0;
		this.columnsUser = [
			{field:"username", header:"Identifiant", sort:"username"},
			{field:"role", header:"Rôle", sort:"role"},
			{field:"name", header:"Nom", sort:"name"},
			{field:"firstname", header:"Prénom", sort:"firstname"},
			{field:"active", header:"Etat propre", sort:"active"}
		];

		// Loading users list.
		this.put("/api/company-detail-list-user", newDatas,
			 (data) => {
				 // Storing list of users.
				 if (data.DATA == "OK") {
					this.datasUser = data.RES;
				} else {
					this.alertLine.alertDangerMessage = "Erreur d'accès à la base de données. Contactez votre administrateur.";
				}
			 },
			 (err) => {
				 this.alertLine.alertDangerMessage = "Erreur d'accès à la base de données. Contactez votre administrateur.";
			 }
		);
	}

	// Fonctions utilitaires.
	public filterColumns(event: Event): string {
		return (<HTMLInputElement> event.target).value;
	}

	// =================
	// Gestion des dossiers.
	// =================
	public prevFolder(): void {
		// Set to the previous folder page.
		this.firstFolder = this.firstFolder - this.rowsFolder;
	}

	public resetFolder(): void {
		// Clear the full folder data.
		this.firstFolder = 0;
	}

	public nextFolder(): void {
		// Set to the next folder page.
		this.firstFolder = this.firstFolder + this.rowsFolder;
	}

	public isFirstPageFolder(): boolean {
    	// Test if the displayed folder page is the first one.
		return this.datasFolder ? this.firstFolder === 0 : true;
	}

	public isLastPageFolder(): boolean {
    	// Test if the displayed folder page is the last one.
		return this.datasFolder ? (this.datasFolder.length - this.firstFolder) < this.rowsFolder : true
	}

	public hasFolder(): boolean {
		// Returns if the list of the folder table is empty.
		return this.datasFolder.length !== 0;
	}

	public doAddFolder(): void {
		var newFolderParams = {
			"FROM": "COMPANY-DETAILS",
			"COMPANY": {id: this._companyId, name: this.companyName}
		};
		this.runModalDialogWithParameters(FolderAddComponent, newFolderParams,
			(result: any) => {
				if (result == "FERMETURE") return;

				switch (result) {
					case "UNAUTHORIZED":
						this.alertLine.alertDangerMessage = "Vous ne disposez pas des droits d'édition.";
						break;
					case "DATABASE":
						this.alertLine.alertDangerMessage = "Erreur de base de données. Contactez votre administrateur.";
						break;
					case "ENTITY ALREADY EXISTS":
						this.alertLine.alertDangerMessage = "Impossible d'ajouter le dossier: Le dossier existe déjà.";
						break;
					case "CANNOT CREATE ENTITY":
						this.alertLine.alertDangerMessage = "Erreur de création de la base de données. Contactez votre administrateur.";
						break;
					case "INVALID DATE":
						this.alertLine.alertDangerMessage = "Date d'arrêt saisie invalide : veuillez saisir une date d'arrêt postérieur à celle du jour.";
						break;
         			default:
						this.alertLine.alertDangerMessage = "Erreur inconnue (" + result.VALUE + "). Contactez votre administrateur.";
						break;
				}
			},
			(reason: any) => {
				// Test if click outside or press space bar the dialog.
				if (reason != 1 && reason != 0) {
					// Inserting new item inside the list.
					var newFolder = {
						"_id": reason["_id"],
						"name": reason["name"],
						"path": reason["path"],
						"endDate": reason["endDate"],
						"endDateVal": reason["endDateVal"],
						"state": "D",
					};

					// Updating for sorting.
					this.datasFolder = [ ...this.datasFolder, newFolder ];

					// Message informatif.
					this.alertLine.alertSuccessMessage = "Dossier ajouté.";
				}
			}
		);
	}

	public doEditFolder(folderName: string, folderId: string, folderEndDate: Date): void {
		this.runModalDialogWithParameters(FolderEditComponent, {name: folderName, id: folderId, endDate: folderEndDate},
			(result: any) => {
				if (result == "FERMETURE") return;

				switch (result) {
					case "UNAUTHORIZED":
						this.alertLine.alertDangerMessage = "Vous ne disposez pas des droits d'édition.";
						break;
					case "NOT FOUND":
						this.alertLine.alertDangerMessage = "Impossible de trouver le dossier à renommer. Merci de recommencer l'opération.";
						break;
					case "DATABASE":
						this.alertLine.alertDangerMessage = "Erreur d'accès à la base de données. Contactez votre administrateur.";
						break;
					case "ENTITY ALREADY EXISTS":
						this.alertLine.alertDangerMessage = "Un dossier porte déjà le nom demandé. Opération annulée.";
						break;
					case "CANNOT UPDATE ENTITY":
						this.alertLine.alertDangerMessage = "Erreur de la mise à jour de la base de données. Contactez votre administrateur.";
						break;
					case "INVALID DATE":
						this.alertLine.alertDangerMessage = "Date d'arrêt saisie invalide : veuillez saisir une date d'arrêt postérieur à celle du jour.";
						break;
					default:
						this.alertLine.alertDangerMessage = "Erreur inconnue (" + result.VALUE + "). Contactez votre administrateur.";
						break;
				}
			},
			(reason: any) => {
				// Test if click outside the dialog.
				if (reason != 1 && reason != 0) {
					for(var folderIndex in this.datasFolder) {
						var folder = this.datasFolder[folderIndex];
						if (folder._id == reason.id) {
							folder.name = reason.name;
							folder.path = reason.path;
							folder.endDate = reason.endDate;
							folder.endDateVal = reason.endDateVal;
							break;
						}
					}

					// Updating the sorting.
					this.filterDataFolder();

					// Message informatif.
					this.alertLine.alertSuccessMessage = "Dossier modifié.";
				}
			}
		);
	}

	public doEditRightsFolder(folderName: string, folderId: string): void {
		var newUserParams = {
			"name": folderName, 
			"id": folderId
		};
		this.runModalDialogWithParameters(FolderEditRightsComponent, newUserParams,
			(result: any) => {
				if (result == "FERMETURE") return;

				switch (result) {
					case "UNAUTHORIZED":
						this.alertLine.alertDangerMessage = "Vous ne disposez pas des droits d'édition.";
						break;
					case "NOT FOUND":
						this.alertLine.alertDangerMessage = "Impossible de trouver le dossier à renommer. Merci de recommencer l'opération.";
						break;
					case "DATABASE":
						this.alertLine.alertDangerMessage = "Erreur d'accès à la base de données. Contactez votre administrateur.";
						break;
					case "CANNOT UPDATE ENTITY":
						this.alertLine.alertDangerMessage = "Erreur de la mise à jour de la base de données. Contactez votre administrateur.";
						break;
					default:
						this.alertLine.alertDangerMessage = "Erreur inconnue (" + result.VALUE + "). Contactez votre administrateur.";
						break;
				}
			},
			(reason: any) => {
				// Test if click outside the dialog.
				if (reason != 1 && reason != 0) {
					var newDatas = { companyid: this._companyId };

					// Loading users list.
					this.put("/api/company-detail-list-folder", newDatas,
						(data) => {
							// Storing list of folders.
							if (data.DATA == "OK") {
								this.datasFolder = [...data.RES];
							} else {
								this.alertLine.alertDangerMessage = "Erreur d'accès à la base de données. Contactez votre administrateur.";
							}
						},
						(err) => {
							this.alertLine.alertDangerMessage = "Erreur d'accès à la base de données. Contactez votre administrateur.";
						}
					);
			
					// Filtering again datas.
					this.filterDataFolder();

					// Message informatif.
					this.alertLine.alertSuccessMessage = "Droits du dossier modifié.";
				}
			}
		);
	}

	public doStartFolder(folderId: string, folderName: string): void {
		this.runModalDialogWithParameters(FolderStartComponent, {id: folderId, name:folderName},
			(result:any) => {
				if (result == "FERMETURE") return;
				this.alertLine.alertDangerMessage = "Impossible de démarrer le dossier.";
			},
			(reason:any) => {
				if (reason != 1 && reason != 0) {
					this.alertLine.alertSuccessMessage = "Dossier démarré.";

					// Replacing the state on the list.
					for(var folderIndex in this.datasFolder) {
						var folder = this.datasFolder[folderIndex];
						if (folder._id == folderId) {
							folder.state = "R";
							break;
						}
					}

					// Fitering again datas.
					this.filterDataFolder();
				}
			}
		);
	}

	public doRestartFolder(folderId: string, folderName: string): void {
		this.runModalDialogWithParameters(FolderRestartComponent, {id: folderId, name:folderName},
			(result:any) => {
				if (result == "FERMETURE") return;
				this.alertLine.alertDangerMessage = "Impossible de redémarrer le dossier.";
			},
			(reason:any) => {
				if (reason != 1 && reason != 0) {
					this.alertLine.alertSuccessMessage = "Dossier redémarré.";

					// Replacing the state on the list.
					for(var folderIndex in this.datasFolder) {
						var folder = this.datasFolder[folderIndex];
						if (folder._id == folderId) {
							folder.state = "R";
							folder.endDate = reason.endDate;
							folder.endDateVal = reason.endDateVal;
							break;
						}
					}

					// Fitering again datas.
					this.filterDataFolder();
				}
			}
		);
	}

	public doEditFolderMail(folderId:string, folderName:string): void {
		this.runModalDialogWithParameters(FolderEditMailComponent, {id: folderId, name:folderName},
			(result:any) => {
				if (result == "FERMETURE") return;

				switch (result) {
					case "UNAUTHORIZED":
						this.alertLine.alertDangerMessage = "Vous ne disposez pas des droits d'édition.";
						break;
					case "NOT FOUND":
						this.alertLine.alertDangerMessage = "Impossible de trouver le dosser à mettre à jour. Merci de recommencer l'opération.";
						break;
					case "DATABASE":
						this.alertLine.alertDangerMessage = "Erreur d'accès à la base de données. Contactez votre administrateur.";
						break;
					case "CANNOT UPDATE ENTITY":
						this.alertLine.alertDangerMessage = "Erreur de la mise à jour de la base de donénes. Contactez votre administrateur.";
						break;
					default:
						this.alertLine.alertDangerMessage = "Erreur inconnue (" + result.VALUE + "). Contactez votre administrateur.";
						break;
				}
			},
			(reason:any) => {
				if (reason != 1 && reason != 0) {
					this.alertLine.alertSuccessMessage = "Email modifié.";
				}
			}
		);
	}

	public doSendFolderReminder(folderId:string, folderName:string): void {
		this.runModalDialogWithParameters(FolderReminderComponent, {id:folderId, name:folderName},
			(result:any) => {
				// Nothing.
			},
			(reason:any) => {
				if (reason != 1 && reason != 0) {
					if (reason.DATA == "OK") {
						this.alertLine.alertSuccessMessage = "Emails de rappel envoyés (Nombre: " + reason.NB + ").";
					} else {
						this.alertLine.alertDangerMessage = "Impossible d'envoyer les emails de rappel. Contactez votre administrateur.";
					}
				}
			}
		);
	}

	public doSendForUpdateFolder(folderId:string): void {
		this.runModalDialogWithParameters(FolderUpdaterComponent, {id:folderId},
			(result:any) => {
				// Nothing.
			},
			(reason:any) => {
				if (reason != 1 && reason != 0) { 
					if (reason.DATA == "OK") {
						this.alertLine.alertSuccessMessage = "Emails de rappel envoyés (Nombre: " + reason.NB + ").";
					} else {
						this.alertLine.alertDangerMessage = "Impossible d'envoyer les emails de rappel. Contactez votre administrateur.";
					}
				}
			}
		);
	}

	public doDeactivateFolder(folderId: string): void {
		// Sending stoping to the server.
		var newData = {
			"folderid": folderId
		};
		this.put("/api/folder-deactivate", newData,
				(response: any) => {
					this.alertLine.alertSuccessMessage = "Dossier désactivé.";
				},
				(err: any) => {
					this.alertLine.alertDangerMessage = "Impossible de désactiver la dossier.";
				});

		// Replacing the state on the list.
		for(var folderIndex in this.datasFolder) {
			var folder = this.datasFolder[folderIndex];
			if (folder._id == folderId) {
				folder.state = "X";
				break;
			}
		}

		// Filtering again datas.
		this.filterDataFolder();
	}

	public doActivateFolder(folderId: string): void {
		// Sending stoping to the server.
		var newData = {
			"folderid": folderId
		};
		this.put("/api/folder-activate", newData,
			(response: any) => {
				this.alertLine.alertSuccessMessage = "Dossier activé.";
				// Replacing the state on the list.
				for(var folderIndex in this.datasFolder) {
					var folder = this.datasFolder[folderIndex];
					if (folder._id == folderId) {
						folder.state = response.RES;
						break;
					}
				}
		
				// Filtering again datas.
				this.filterDataFolder();
			},
			(err: any) => {
				this.alertLine.alertDangerMessage = "Impossible d'activer la dossier.";
		});
	}

	public filterDataFolder(): void {
		// Force filtering after modifying data.
		this.datasFolder = [ ...this.datasFolder];
	}

	// =================
	// Gestion des users.
	// =================
	public prevUser(): void {
		this.firstUser = this.firstUser - this.rowsUser;
	}

	public resetUser(): void {
		this.firstUser = 0;
	}

	public nextUser(): void {
		this.firstUser = this.firstUser + this.rowsUser;
	}

	public hasUser(): boolean {
		if (this.datasUser === []) return false;
		return this.datasUser.length > 0;
	}

	public isFirstPageUser(): boolean {
		return this.datasUser ? this.firstUser === 0 : true;
	}

	public isLastPageUser(): boolean {
		return this.datasUser ? (this.datasUser.length - this.firstUser) < this.rowsUser : true;
	}

	public doEditUser(userId: string, userName:string): void {
		this.runModalDialogWithParameters(UserEditComponent, {id:userId, username:userName, companyName: this.companyName},
			(result:any) => {
				if (result == "FERMETURE") return;

				switch (result) {
					case "UNAUTHORIZED":
						this.alertLine.alertDangerMessage = "Vous ne disposez pas des droits d'édition.";
						break;
					case "ENTITY ALREADY EXISTS":
						this.alertLine.alertDangerMessage = "Un utilisateur porte déjà le nom demandé. Opération annulée.";
						break;
					case "NOT FOUND":
						this.alertLine.alertDangerMessage = "Impossible de trouver l'utilisateur à éditer. Merci de recommencer l'opération.";
						break;
					case "DATABASE":
						this.alertLine.alertDangerMessage = "Erreur d'accès à la base de données. Contactez votre administrateur.";
						break;
					case "CANNOT UPDATE ENTITY":
						this.alertLine.alertDangerMessage = "Erreur de la mise à jour de la base de données. Contactez votre administrateur.";
						break;
					default:
						this.alertLine.alertDangerMessage = "Erreur inconnue (" + result.VALUE + "). Contactez votre administrateur.";
						break;
				}
			},
			(reason:any) => {
				// Test if click outside or press space bar the dialog.
				if (reason != 1 && reason != 0) {
					if (reason.company != this._companyId) {
						// The user's company has been changed.
						this.datasUser = this.datasUser.filter(user => user._id != reason.id);
					} else {
						for(var userIndex in this.datasUser) {
							var user = this.datasUser[userIndex];
							if (user._id == reason.id) {
								user.name = reason.name.trim().toUpperCase();
								user.firstname = reason.firstname.charAt(0).toUpperCase() + reason.firstname.trim().slice(1);
								user.role = reason.role;
								break;
							}
						}
					}

					// Updating the sorting.
					this.filterDataUser();
					
					// Informations.
					this.alertLine.alertSuccessMessage = "Utilisateur modifié.";
				}
			}
		);
	}

	public doActivateUser(userId: string): void {
		// Sending activation to the server.
		var newData = {
			"userid": userId
		};
		this.put("/api/user-activate", newData,
			(response:any) => {
				if (response.DATA == "ERR") {
					this.alertLine.alertDangerMessage = "Impossible d'activer l'utilisateur.";
				} else {
					this.alertLine.alertSuccessMessage = "Utilisateur activé.";
				
					// Replacing the state on the list.
					for(var userIndex in this.datasUser) {
						var user = this.datasUser[userIndex];
						if (user._id == userId) {
							user.active = true;
							break;
						}
					}

					// Filtering again datas.
					this.filterDataUser();
				}
			},
			(err:any) => {
				this.alertLine.alertDangerMessage = "Impossible d'activer l'utilisateur.";
			}
		);
	}

	public doDeactivateUser(userId: string): void {
		var newData = {
			"userid": userId
		};
		this.put("/api/user-deactivate", newData,
			(response:any) => {
				if (response.DATA == "ERR") {
					this.alertLine.alertDangerMessage = "Impossible de désactiver l'utilisateur.";
				} else {
					this.alertLine.alertSuccessMessage = "Utilisateur désactivé.";

					// Replacing the state on the list.
					for(var userIndex in this.datasUser) {
						var user = this.datasUser[userIndex];
						if (user._id == userId) {
							user.active = false;
							break;
						}
					}

					// Filtering again datas.
					this.filterDataUser();
				}
			},
			(err:any) => {
				this.alertLine.alertDangerMessage = "Impossible de désactiver l'utilisateur.";
			}
		);

		
	}

	public doGenerateNewUserPassword(userId: string, userName: string): void {
		this.runModalDialogWithParameters(UserGenerateNewPasswordComponent, {id: userId, username:userName},
			(result:any) => {
				if (result == "FERMETURE") return;
				this.alertLine.alertDangerMessage = "Impossible de réinitialiser le mot de passe. Contactez votre administrateur.";
			},
			(reason:any) => {
				if (reason != 1 && reason != 0) {
					this.alertLine.alertSuccessMessage = "Mot de passe réinitialisé.";
				}
			}
		);
	}

	public doAddUser(): void {
		var newUserParams = {
			"FROM": "COMPANY-DETAILS",
			"COMPANY_ID": this._companyId
		};
		this.runModalDialogWithParameters(UserAddComponent, newUserParams,
			(result:any) => {
				if (result == "FERMETURE") return;

				switch (result) {
					case "UNAUTHORIZED":
						this.alertLine.alertDangerMessage = "Vous ne disposez pas des droits d'édition.";
						break;
					case "DATABASE":
						this.alertLine.alertDangerMessage = "Erreur de base de données. Contactez votre administrateur.";
						break;
					case "ENTITY ALREADY EXISTS":
						this.alertLine.alertDangerMessage = "Impossible d'ajouter l'utilisateur: L'utilisateur existe déjà.";
						break;
					case "CANNOT CREATE ENTITY":
						this.alertLine.alertDangerMessage = "Erreur de création de la base de données. Contactez votre administrateur.";
						break;
					default:
						this.alertLine.alertDangerMessage = "Erreur inconnue (" + result.VALUE + "). Contactez votre administrateur.";
					break;
				}
			},
			(reason:any) => {
				// Test if click outside or press space bar.
				if (reason != 1 && reason != 0) {
					// Inserting new item inside the list.
					var newUser = {
						"_id": reason["_id"],
						"username": reason["username"],
						"role": reason["role"],
						"active": reason["active"],
						"name": reason["name"],
						"firstname": reason["firstname"]
					};

					// Update.
					this.datasUser = [ ...this.datasUser, newUser];

					// Info.
					this.alertLine.alertSuccessMessage = "Utilisateur ajouté.";
				}
			}
		);
	}

	public filterDataUser(): void {
		// Force filtering after modifying data.
		this.datasUser = [ ...this.datasUser];
	}
}
